export enum Rol {
  SuperAdmin = 1,
  Admin = 2,
}

export const isAdminRole = (roleId?: number | string): boolean => [Rol.SuperAdmin, Rol.Admin].includes(Number(roleId));
